/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label.bold[_ngcontent-%COMP%]{font-weight:600}.required-asterisk[_ngcontent-%COMP%]{color:#e74c3c;margin-left:2px}.margin-y-10[_ngcontent-%COMP%]{margin-top:20px;margin-bottom:20px}\n/*# sourceMappingURL=redeem-create.component.css.map*/"];
export { styles as styles };
